import React, {Component} from 'react';
import {Row, Col, Form, Button, Input} from 'antd';
import {api, app} from "../../app";

const FormItem = Form.Item;

class UpPwd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            update_loading: false
        };
    }

    /**
     * 提交信息
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const _this = this, update_loading = this.state.update_loading;
                if (update_loading) return false;
                this.setState({update_loading: true});
                values.token = app.getToken();
                values.indexno = app.getData('indexno');
                values.account = app.getData('account');
                app.post(api.UpdatePwd, values).then(({flag, msg}) => {
                    if (flag === 1) {
                        app.alert("修改成功~", "success");
                        app.clearInfo(_this.props.history);
                    } else {
                        app.alert(msg, "error");
                    }
                    _this.props.form.resetFields();
                    _this.setState({update_loading: false});
                });
            }
        })
    }

    /**
     * 检查密码
     * @param rule
     * @param value
     * @param callback
     */
    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('new_password')) {
            callback('您输入的两个密码不一致!');
        } else if (value === form.getFieldValue('password')) {
            callback('您输入的新密码不能与当前密码一致!');
        } else {
            callback();
        }
    }

    /**
     * 检查密码长度
     * @param rule
     * @param value
     * @param callback
     */
    checkLength = (rule, value, callback) => {
        if (value && value.length < 8) {
            callback('密码最少8位!');
        } else {
            callback();
        }
    }

    render() {
        const {getFieldDecorator} = this.props.form,
            formItemLayout = {
                labelCol: {span: 5},
                wrapperCol: {span: 16, offset: 1}
            }, update_loading = this.state.update_loading;
        return (
            <div className="member-page update-pwd">
                <div className="member-page-title">修改密码</div>
                <Row className="mp-content">
                    <Form onSubmit={this.handleSubmit}>
                        <FormItem
                            label="当前密码"
                            {...formItemLayout}
                        >
                            {getFieldDecorator('password', {
                                rules: [{required: true, message: '请输入您当前的密码!'}, {
                                    validator: this.checkLength,
                                }],
                            })(
                                <Input type="password" placeholder="请输入您当前的密码"/>
                            )}
                        </FormItem>
                        <FormItem
                            label="新密码"
                            {...formItemLayout}
                        >
                            {getFieldDecorator('new_password', {
                                rules: [{required: true, message: '请输入您的新密码!'}, {
                                    validator: this.checkLength,
                                }],
                            })(
                                <Input type="password" placeholder="请输入您的新密码"/>
                            )}
                        </FormItem>
                        <FormItem
                            label="确认密码"
                            {...formItemLayout}
                        >
                            {getFieldDecorator('confirm_password', {
                                rules: [{required: true, message: '请确认您的新密码!'}, {
                                    validator: this.checkPassword,
                                }, {
                                    validator: this.checkLength,
                                }],
                            })(
                                <Input type="password" placeholder="请确认您的新密码"/>
                            )}
                        </FormItem>
                        <Row type="flex" justify="center" style={{paddingBottom: 25}}>
                            <Button type="primary" htmlType="submit" loading={update_loading}>确认修改</Button>
                        </Row>
                    </Form>
                </Row>
            </div>
        );
    }
}

export default Form.create()(UpPwd);



// WEBPACK FOOTER //
// ./src/routes/playerInfo/UpPwd.jsx